// Taron adds a flat $2 logo-box charge to every order. It rides along as a
// product rather than a fee so the kitchen ticket and the receipt both show it,
// and so it is taxed the same way the food is.
//
// The charge is virtual: it is never written into cart state. Cart state is
// persisted to localStorage and the checkout page prunes items that are no
// longer on the menu, so a real cart product would need dedupe-on-remount and
// would be removable by the customer. Injecting it at checkout time keeps it
// exactly $2, exactly once, and not deletable.

export const CUSTOM_BOX_CHARGE_SHOP_IDS = [
  'taronglendale',
]

export const CUSTOM_BOX_CHARGE_PRICE = 2

// Stable id so React keys and the kitchen ticket do not churn between renders.
export const CUSTOM_BOX_CHARGE_ID = 'custom-box-charge'

export function hasCustomBoxCharge (shopId) {
  return CUSTOM_BOX_CHARGE_SHOP_IDS.indexOf(shopId) !== -1
}

// Returns the synthetic product for the shop, or null when it does not apply.
// An empty cart gets no charge — there is no order to box.
export function getCustomBoxCharge (shopId, products) {
  if (!hasCustomBoxCharge(shopId)) { return null }
  if (!products || !products.length) { return null }
  return {
    id: CUSTOM_BOX_CHARGE_ID,
    name: { en: 'Taron Bakery logo box (mandatory charge)' },
    price: CUSTOM_BOX_CHARGE_PRICE,
    quantity: 1,
    modgroups: [],
    customerPicks: {},
  }
}

// The cart products plus the charge, for totals and for the submitted order.
export function withCustomBoxCharge (shopId, products) {
  const charge = getCustomBoxCharge(shopId, products)
  return charge ? [...products, charge] : products
}
